export default __webpack_public_path__ + "static/media/08AW1JUL66.d5cae6a1.jpg";